import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';

import {MessageRecipient} from '../models';
import {ChatMessageAdapter} from './chat-message-adapter.service';

const msgBodyLimit = 150;
const msgBodyShortLimit = 40;

@Injectable()
export class ChatMessageRecipientAdapter implements IAdapter<MessageRecipient> {
  constructor(private readonly chatMsgAdapter: ChatMessageAdapter) {}

  adaptToModel(resp: any): MessageRecipient {
    const recipient: MessageRecipient = new MessageRecipient();
    Object.assign(recipient, resp);
    if (resp.message) {
      recipient.message = this.chatMsgAdapter.adaptToModel(resp.message);
      recipient.messageBody = `${recipient.message.body.substring(
        0,
        msgBodyLimit,
      )}${recipient.message.body.length > msgBodyLimit ? '....' : ''}`;
      recipient.messageBodyShort = `${recipient.message.body.substring(
        0,
        msgBodyShortLimit,
      )}${recipient.message.body.length > msgBodyShortLimit ? '....' : ''}`;
      recipient.messageTitle = `${
        recipient.message.sender ? recipient.message.sender.fullName : ''
      }`;
    }
    return recipient;
  }
  adaptFromModel(data: MessageRecipient): any {
    const dataToSend = Object.assign({}, data);
    delete dataToSend.messageBody;
    delete dataToSend.messageTitle;
    return data;
  }
}
